// Get Raised Queries Use Case
import { QueriesRepository } from "../repositories/QueriesRepository";
import {
  QueryEntity,
  QueryFilters,
  QueryListResult,
} from "../entities/QueryEntity";
import { Result } from "../common/Result";

export class GetRaisedQueriesUseCase {
  constructor(private repository: QueriesRepository) {}

  async execute(
    userId: number,
    filters?: QueryFilters,
    limit: number = 20,
    offset: number = 0
  ): Promise<Result<QueryListResult>> {
    try {
      if (!userId || userId <= 0) {
        return Result.fail("Invalid user ID");
      }

      const queries = await this.repository.getRaisedByMe(
        userId,
        filters,
        limit,
        offset
      );
      return Result.ok(queries);
    } catch (error: any) {
      return Result.fail(error.message || "Failed to fetch raised queries");
    }
  }
}

